import api from "utils/axios";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";

// In public.js
export const useHolidays = (options = {}) =>
  useQuery({
    queryKey: ["holidays"],
    queryFn: async () => {
      const res = await api.get("/public/holidays");
      return res.data;
    },
    select: (data) => data?.data || [], // Transform the response
    staleTime: 1000 * 60 * 60,
    gcTime: 1000 * 60 * 60 * 24,
    refetchOnWindowFocus: false,
    ...options,
  });

export const useRawImageConversion = (options = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ imageUrl, imageId, revisionId }) => {
      // Check cache first
      const cacheKey = ["rawImageConversion", imageUrl];
      const cachedData = queryClient.getQueryData(cacheKey);

      if (cachedData) {
        return { ...cachedData, imageId, revisionId };
      }

      // If not cached, make API call
      const response = await axios.post(
        "https://image-service.beleef.com.au/api/v1/uploadCr3",
        { imageUrl }
      );

      const result = {
        imageId,
        revisionId,
        originalUrl: imageUrl,
        convertedUrl: response.data.base64Image,
      };

      // Cache the result
      queryClient.setQueryData(cacheKey, result);

      return result;
    },
    gcTime: 1000 * 60 * 10, // 10 minutes
    ...options,
  });
};
